import { TourConfig } from '../models/tour-config.model';
import { TourFeature } from '../config/tour-feature.enum';
import { Audience } from '../config/audience.enum';
import { TourTrigger } from '../config/trigger.enum';
import { AnchorId } from '../config/anchor.registry';

/**
 * MENTOR AP-8 (§7a) — Folgen-Hilfe „Freigabe zuruecknehmen" (D-17c).
 *
 * Kontextuelle `?`-Tour fuer den `unpublish-week-dialog`. Der Dialog oeffnet
 * ausschliesslich aus dem ⋯-Overflow des Planers — kein deterministischer
 * Opener-Anker, daher KEIN `launchContext`: nur ueber den In-Dialog-`?`-Button
 * startbar.
 *
 * Drei Schritte entlang der Folgenmatrix §7a: Reichweite („ganze sichtbare
 * Woche") → Mitarbeiterwirkung (Benachrichtigen-Schalter) → bewusster Klick.
 * Sicherheitsbruecke: Schichten bleiben als Entwurf erhalten — es wird nichts
 * geloescht.
 */
const DIALOG_CTX = { attachToDialog: true, autoCloseOnDialogClose: true };

export const UNPUBLISH_WEEK_HELP_TOUR: TourConfig = {
  id: TourFeature.UnpublishWeekHelp,
  version: 1,
  title: 'TUTORIAL.UNPUBLISH_WEEK.TITLE',
  description: 'TUTORIAL.UNPUBLISH_WEEK.DESC',
  audience: [Audience.Admin, Audience.TeamLeader],
  triggers: [TourTrigger.Manual],
  statePolicy: {
    allowReplay: true,
    snoozeEnabled: false,
    cooldownHoursAfterDismiss: 0,
    cooldownHoursAfterSnooze: 0,
    suppressAfterCompletion: false,
  },
  priority: 100,
  estimatedDurationSec: 60,
  category: 'feature-discovery',
  chapters: [
    {
      id: 'overview',
      title: 'TUTORIAL.UNPUBLISH_WEEK.TITLE',
      steps: [
        {
          // Was passiert hier + Reichweite „ganze sichtbare Woche".
          id: 'scope',
          anchor: AnchorId.UnpublishWeekScope,
          spotlightAnchor: AnchorId.UnpublishWeekDialog,
          title: 'TUTORIAL.UNPUBLISH_WEEK.SCOPE.TITLE',
          content: 'TUTORIAL.UNPUBLISH_WEEK.SCOPE.CONTENT',
          placement: 'bottom',
          dialogContext: { ...DIALOG_CTX, popoverOutsideDialog: true },
          nextCondition: 'manual',
          showNextButton: true,
          showPrevButton: false,
        },
        {
          // Mitarbeiterwirkung: stille Ruecknahme vs. Info.
          id: 'notify',
          anchor: AnchorId.UnpublishWeekNotify,
          spotlightAnchor: AnchorId.UnpublishWeekNotify,
          title: 'TUTORIAL.UNPUBLISH_WEEK.NOTIFY.TITLE',
          content: 'TUTORIAL.UNPUBLISH_WEEK.NOTIFY.CONTENT',
          placement: 'bottom',
          dialogContext: DIALOG_CTX,
          nextCondition: 'manual',
          showNextButton: true,
        },
        {
          // Bewusster Abschluss + Sicherheitsbruecke „bleibt Entwurf".
          id: 'confirm',
          anchor: AnchorId.UnpublishWeekConfirm,
          spotlightAnchor: AnchorId.UnpublishWeekConfirm,
          title: 'TUTORIAL.UNPUBLISH_WEEK.CONFIRM.TITLE',
          content: 'TUTORIAL.UNPUBLISH_WEEK.CONFIRM.CONTENT',
          placement: 'top',
          dialogContext: DIALOG_CTX,
          nextCondition: 'manual',
          showNextButton: true,
        },
      ],
    },
  ],
};
